import { useLocalizedStrings } from 'i18n';

/**
 * Wait for app initialization to complete (like loading translations) before rendering the app
 *
 * @param props
 * @param props.children
 * @param props.fallback
 */
export const WaitForInitialization = (props: { children: JSX.Element; fallback: JSX.Element }) => {
  const { children, fallback } = props;
  const { ready: translationsReady } = useLocalizedStrings();

  if (translationsReady) {
    return children;
  }
  return fallback;
};
